var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 136,
    viewBox: "0 0 124 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 68L123.5 0.883026L123.5 135.117L0.5 68Z",
    fill: "#121415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 68L108.5 24.6987L108.5 111.301L29 68Z",
    fill: "#E2DFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/left-button.38e3e463ed32194f6ae61a8827bd38d1.svg";
export { ForwardRef as ReactComponent };